import React from 'react';

export default function PageNotFound(){
    return (
        <>
            <h1>Page Not Found</h1>
            <a href="/">Click here to visit login page</a>
        </>
    )
}